
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_1","data-name":"Capa 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M46.17 41.79a6.67 6.67 0 01-1.12 3.54c10.92 9.75 26.52 12.74 33 13.61 0-3.63-.88-9.16-4.06-17.41H46.12c0 .08.05.16.05.26z"}}),_c('path',{attrs:{"d":"M65 44.44c2.6 4.5 5.13 9 7.67 13.58 2.11.43 4 .73 5.36.91 0-3.63-.88-9.16-4.06-17.41H63.31c.58.97 1.16 1.94 1.69 2.92z","fill":"#0071ff"}}),_c('path',{attrs:{"d":"M39.2 43.33a5.85 5.85 0 015.85-5.85h27.19c-.09-.2-.16-.37-.25-.57C61.58 14.33 37 16.36 27 31.64s-2 28.93-2 28.93L66.45 74.9l9.87-11.36A75.24 75.24 0 0157.89 58C49.13 53.94 39.2 46.45 39.2 43.33z","fill":"#222221"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M59.84 37.48h12.4c-.09-.2-.16-.37-.25-.57-6.83-14.82-19.78-19-30.7-15.87z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M22.81 54.91a23.84 23.84 0 002.13 5.66L66.45 74.9l2.28-2.62c-3.4-1.33-46.04-17.86-45.92-17.37z"}}),_c('path',{attrs:{"d":"M44 56.52a11.28 11.28 0 0111.15 9.69 11.27 11.27 0 10-22.3 0A11.27 11.27 0 0144 56.52z","fill":"#dfe5f4"}}),_c('path',{attrs:{"d":"M44 75.9a11.27 11.27 0 0011.15-9.69 11.26 11.26 0 00-22.3 0A11.26 11.26 0 0044 75.9z","fill":"#fff"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M44.09 58.01h-2.3v8.14l7.03 4.05 1.65-1.86-5.38-4.11-1-6.22z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M44 49.3a15.32 15.32 0 1015.32 15.32A15.32 15.32 0 0044 49.3zm0 26.39a11.15 11.15 0 1110.94-9.51A11 11 0 0144 75.69z"}})])
          )
        }
      }
    